<template>
  <main
    class="min-h-dvh w-full bg-gradient-to-b from-[#F8F8F6] to-[#E9DBE6] text-black flex justify-center items-center px-6"
  >
    <div class="flex items-center absolute top-8 left-6 sm:left-8">
      <UiIcon name="custom-icons:violet" size="md" />
      <h1 class="pl-2 text-base font-medium">CAOBOT</h1>
    </div>

    <div class="w-full max-w-lg flex flex-col items-center text-center">
      <div class="font-medium leading-none text-6xl sm:text-7xl md:text-[5rem]">
        {{ props.error?.statusCode || "404" }}
      </div>

      <p class="mt-3 text-base sm:text-xl md:text-3xl break-words">
        {{ props.error?.statusMessage || "Oops er gaat iets fout..." }}
      </p>

      <UiButton
        class="rounded-[87px] btn w-full max-w-[303px] justify-center p-2 bg-[#212121] text-[#FFF] my-8 text-sm"
        label="Ga terug"
        icon="custom-icons:terug"
        icon-position="left"
        iconSize="md"
        @click="goBack"
      />
    </div>
  </main>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";
const router = useRouter();

const props = defineProps<{ error: NuxtError }>();

const goBack = () => {
  router.back();
};
</script>
